


















































import { Component, Vue } from 'vue-property-decorator'
import db from '@/firebase/firebaseConfig'
import Comment from '@/components/Comment.vue'
import LikeButton from '@/components/LikeButton.vue'
@Component({
  name: 'ViewIdea',
  components: {
    Comment,
    LikeButton,
  }
})
export default class ViewIdea extends Vue {

  idea: any = null

  created() {
    db.collection('ideas').doc(this.$route.params.id)
    .get().then(doc => {
        this.idea = doc.data()
        this.idea.contentMain = this.idea.contentMain.replace(/\n/g, '<br>')
    })
  }
}
